export default __webpack_public_path__ + "static/media/not-found.5a4306dd.jpg";